module.exports = __webpack_public_path__ + "static/media/effortless-img.d1ca9cc3.webp";